import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  DatePicker,
  Popconfirm,
  Select,
  Table,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined, EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services.js";
import { ApiURL, generatecargopdf } from "../../../services/apiConstants.js";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast.js";
import VoyageDetails from "../../../components/VoyageDetails.js";
import useVoyageList from "../../../hooks/useVoyageList.js";
import useUserData from "../../../hooks/useUserData.js";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data.js";
import { DOWNLOADPDF } from "../../../utils/downloadPdf.js";
import RequestFormModal_cargo_record from "../../../components/RequestModel_cargo_record.js";

const { RangePicker } = DatePicker;

const ListCargoRecordBook = () => {
  const navigate = useNavigate();
  const user = useUserData();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [isModalVisible, setModalVisible] = useState(false);
  const [record_id, set_record_id] = useState("");
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD")) || [];

  useEffect(() => {
    const staffData = JSON.parse(
      localStorage.getItem("staff_dashboard") || "{}"
    );
    set_staff_dashboard(staffData);
  }, []);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find(
        (voyage) => voyage.voyage_status === true
      );
      set_voyage_status(runningVoyage?.voyage_status || false);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage?.id) LIST_CARGO_RECORD_BOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_CARGO_RECORD_BOOK_API = (voyage_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id);
      post(ApiURL.list_cargo_records_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res.records?.map((item) => ({
            ...item,
            key: item.record_id.toString(),
            masterReviewed: item.reviewed_by_master || false,
            k_code:
              item.reviewed_by_master && item.operation_code == "K"
                ? false
                : true,
          }));
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const onDeleteCargoRecord = (cargo_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("cargo_id", cargo_id);
    post(ApiURL.delete_cargo_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success!!", "Cargo Record Details Successfully deleted.");
        LIST_CARGO_RECORD_BOOK_API(voyage_ids);
      } else {
        ErrorToast("Error", "Sorry Cargo Record details not deleted ");
      }
    });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.record_id - b.record_id,
      render: (text, record) => (
        <span
          style={record?.soft_delete ? { textDecoration: "line-through" } : {}}
        >
          {record?.record_id}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      align: "center",
      key: "date",
      render: (text, record) => (
        <span
          style={record?.soft_delete ? { textDecoration: "line-through" } : {}}
        >
          {record?.date}
        </span>
      ),
    },
    {
      title: "Code Letter",
      dataIndex: "operation_code",
      align: "center",
      key: "operation_code",
      render: (text, record) => (
        <span
          style={record?.soft_delete ? { textDecoration: "line-through" } : {}}
        >
          {record?.operation_code}
        </span>
      ),
    },
    {
      title: "Cargo Sign",
      dataIndex: "cargo_sign",
      align: "center",
      key: "cargo_sign",
      render: (cargo_sign, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {cargo_sign}
        </span>
      ),
    },

    {
      title: (
        <Tooltip title={"No selections"}>
          <div style={{ textAlign: "center" }}>
            <span>Reviewed By Master</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.masterReviewed)
              }
              indeterminate={
                filteredData.some((item) => item.masterReviewed) &&
                !filteredData.every((item) => item.masterReviewed)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "master_review",
      align: "center",
      key: "master_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.masterReviewed} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Reviewed By Master
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <>
          {!record?.record_for_k && (
            <>
              {(() => {
                const isCaptain = user?.data?.designation === "Captain";
                const isSoftDeleted = record?.soft_delete;
                const reviewed = record?.reviewed_by_master;
                const K_code = record?.k_code;

                const handleEdit = () => {
                  if (reviewed && isCaptain) {
                    setModalVisible(!isModalVisible);
                    set_record_id(record?.record_id);
                  } else {
                    navigate(`/edit-cargo-record/${btoa(record?.record_id)}`);
                  }
                };

                const viewButton = (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      size="small"
                      onClick={() =>
                        navigate(
                          `/view-cargo-record/${btoa(record?.record_id)}`
                        )
                      }
                      style={{ marginRight: "5px" }}
                      icon={<EyeFilled />}
                    />
                  </Tooltip>
                );

                if (!isSoftDeleted && isCaptain && K_code) {
                  return (
                    <>
                      <Tooltip
                        title={
                          !voyage_status
                            ? "Editing is disabled when voyage status is inactive."
                            : "Edit"
                        }
                      >
                        <span>
                          <Button
                            disabled={!voyage_status}
                            type="primary"
                            size="small"
                            onClick={handleEdit}
                            style={{ marginRight: "15px" }}
                            icon={<EditOutlined />}
                          />
                        </span>
                      </Tooltip>

                      <Popconfirm
                        title="Delete Cargo Log"
                        description="Are you sure you want to delete this Cargo Log? This action cannot be undone."
                        onConfirm={() => onDeleteCargoRecord(record?.record_id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Tooltip title="Delete">
                          <Button
                            type="primary"
                            size="small"
                            icon={<DeleteOutlined />}
                          />
                        </Tooltip>
                      </Popconfirm>
                      <Tooltip title="View">
                        <Button
                          type="primary"
                          size="small"
                          onClick={() => {
                            localStorage.setItem("viewOnly", 0);
                            navigate(
                              `/view-cargo-record/${btoa(record?.record_id)}`
                            );
                          }}
                          style={{ marginLeft: "15px" }}
                          icon={<EyeFilled />}
                        />
                      </Tooltip>
                    </>
                  );
                }

                return viewButton;
              })()}
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-cargo-record"),
          onPress: () => navigate("/audit-trail-cargo-record"),
        }}
      />
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find(
                (voyage) => voyage.id === value
              );
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_CARGO_RECORD_BOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color:
                        voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(generatecargopdf, voyage_ids, startDate, endDate)
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
      <RequestFormModal_cargo_record
        visible={isModalVisible}
        record_id={record_id}
        voyage_ids={voyage_ids}
        setModalVisible={setModalVisible}
        onCancel={() => {
          setModalVisible(!isModalVisible);
        }}
      />
    </>
  );
};

export default ListCargoRecordBook;
